import zh from 'iview/dist/locale/zh-TW'
import zhE from 'element-ui/lib/locale/lang/zh-TW'

const zhCn = Object.assign({
  menu: {
    home: '首頁',
    system: '系統管理',
    system_management: {
      Role: '角色',
      Department: '部門',
      Account: '帳號',
      WorkTime: '班次',
      WorkType: '工種',
      RoleEdit: '角色管理',
      DepartmentEdit: '部門編輯',
      AccountEdit: '帳號編輯',
      WorkTimeEdit: '班次編輯',
      WorkTypeEdit: '工種編輯',
      systeminfo: '系統資訊',
      SystemAuth: '授權管理'
    },
    Device: '設備管理',
    Device_management: {
      RouterList: '路由器',
      RouterEdit: '路由器編輯',
      Collector: '機台',
      CollectorEdit: '機台編輯',
      CollectorGroup: '機台分組',
      CollectorGroupEdit: '機台分組編輯'
    },
    Card: '卡片管理',
    CardEdit: '卡片編輯',
    People: '人員管理',
    PeopleEdit: '人員編輯',
    Product: '產品管理',
    ProductEdit: '產品編輯',
    Order: '訂單管理',
    OrderEdit: '訂單編輯',
    Plan: '排產管理',
    Plan_Management: {
      Production_plan: '訂單計畫安排',
      Production_management: '投(停)產管理',
      Production_order: '已排產訂單'
    },
    Monitor: '即時監控',
    Monitor_Monitoring: {
      Collector: '機台監控',
      Order: '訂單監控'
    },
    Data: '歷史報表',
    Data_output: {
      Order: '訂單統計',
      device: '設備統計',
      Worker: '人員統計',
      MaintainList: '維修管理',
      MaintainEdit: '維修編輯'
    },
    Setting: '個人設置'
  },
  system: {
    Account: {
      New_account: '新建帳號',
      edit_account: '編輯帳號',
      please_enter: '請輸入',
      please_choose: '請選擇',
      Return_to_account_list: '返回帳號列表',
      User_name: '用戶名',
      User_name_message: '請輸入用戶名',
      Name: '姓名',
      Name_message: '請輸入姓名',
      Role: '角色',
      Role_message: '請選擇角色',
      Worker_number: '工號',
      Department: '部門',
      Department_message: '請選擇部門',
      Telephone: '電話',
      Email: '電子郵箱',
      QQ: 'QQ',
      Wechat: '微信',
      telephone: '電話：',
      email: '電郵：',
      qq: 'ＱＱ帳號：',
      wechat: '微信帳號：',
      save: '保存',
      index: '序號',
      operating: '操作',
      edit: '編輯',
      delete: '刪除',
      reseat: '重設',
      error: '錯誤',
      error_message1: '<p>帳號重複</p>',
      error_message2: '<p>帳號重複</p>',
      delete_message: '確實要刪除嗎?'
    },
    Department: {
      New_Department: '新建部門',
      edit_Department: '編輯部門',
      index: '序號',
      Department: '部門',
      Authorization: '權限',
      operating: '操作',
      edit: '編輯',
      delete: '刪除',
      delete_message: '確定要刪除嗎?',
      please_enter: '請輸入',
      Return_to_depatement_list: '返回部門列表',
      name: '名稱',
      Move_left: '向左移動',
      Move_right: '向右移動',
      save: '保存',
      All_authorization: '全部許可權',
      Department_authorization: '部門許可權'
    },
    Role: {
      New_Role: '新建角色',
      edit_Role: '編輯角色',
      index: '序號',
      Role: '角色',
      Authorization: '權限',
      operating: '操作',
      edit: '編輯',
      delete: '刪除',
      delete_message: '確定要刪除嗎?',
      please_enter: '請輸入',
      Return_to_role_list: '返回角色列表',
      name: '名稱',
      Move_left: '向左移動',
      Move_right: '向右移動',
      save: '保存',
      All_authorization: '全部權限',
      Role_authorization: '角色權限'
    },
    workTime: {
      New_workTime: '新建班次',
      edit_workTime: '編輯班次',
      index: '序號',
      name: '名稱',
      operating: '操作',
      edit: '編輯',
      delete: '刪除',
      delete_message: '確定要刪除嗎?',
      please_enter: '請輸入',
      please_choose: '選擇時間',
      startTime: '開始時間',
      endTime: '結束時間',
      Return_to_workTime_list: '返回班次列表',
      save: '保存'
    },
    workType: {
      New_workType: '新建工種',
      edit_workType: '編輯工種',
      index: '序號',
      name: '名稱',
      operating: '操作',
      edit: '編輯',
      delete: '刪除',
      delete_message: '確實要刪除嗎?',
      please_enter: '請輸入',
      Return_to_workType_list: '返回工種列表',
      save: '保存',
      yes: '是',
      no: '否',
      outputValid: '計算產量',
      monopoly: '獨佔機台',
      maintain: '維修模式',
      warn: '停機報警',
      Sorting: '排序',
      display: '顯示看板',
      malfunction: '故障計算',
      remark: '備註'
    },
    SystemAuth: {
      Information: '基本資訊',
      systemVersion: '系統版本:',
      systemDealTime: '到期日期:',
      please_enter: '請輸入',
      save: '保存',
      save_success: '保存成功',
      systemAuthCode: '授權碼:'
    },
    SystemInfo: {
      Information: '基本資訊',
      Contect: '聯繫方式',
      systemName: '系統名稱:',
      please_enter: '請輸入',
      name: '企業名稱:',
      contact: '聯繫人:',
      address: '企業地址',
      phone: '聯絡電話:',
      fax: '傳真號碼:',
      eMail: '電子郵箱:',
      save: '保存',
      save_success: '保存成功',
      warnLimitTime: '停機報警間隔:'
    }
  },
  device: {
    collector: {
      New_collector: '新建機台',
      edit_collector: '編輯機台',
      Return_to_collector_list: '返回機台列表',
      name: '名稱',
      deviceNo: '編號',
      routerID: '路由器',
      type: '機器類型',
      computeType: '產能計算方式',
      roller: '滾筒',
      weft_density: '緯密',
      length: '滾筒周長',
      count: '條數',
      width: '出帶寬度',
      deviceCompany: '機器製造商',
      deviceModel: '機器型號',
      buyTime: '機器購買時間',
      deviceLifeTime: '預估使用年限',
      please_enter: '請輸入',
      please_enter_mm: '請輸入(單位:mm)',
      save: '保存',
      operating: '操作',
      edit: '編輯',
      delete: '刪除',
      delete_message: '確定要刪除嗎?',
      error: '錯誤',
      error_message1: '<p>有資料未填寫</p>',
      error_message2: '必須整數',
      remark: '備註',
      Message: {
        name: '請輸入名稱',
        deviceNo: '請輸入編號',
        computeType: '請選擇計算方式',
        routerID: '請選擇所屬路由器',
        length: '請輸入滾筒周長',
        count: '請輸入條數',
        width: '請輸入出帶寬度'
      }
    },
    group: {
      New_group: '新建機器群組',
      edit_group: '編輯機器群組',
      Return_to_group_list: '返回機器群組列表',
      please_enter: '請輸入',
      save: '保存',
      operating: '操作',
      edit: '編輯',
      delete: '刪除',
      delete_message: '確定要刪除嗎?',
      index: '序號',
      name: '名稱',
      devices: '機器',
      chosen: '已選擇',
      remark: '備註',
      width: '寬度',
      router: '路由器'
    },
    router: {
      New_router: '新建路由器',
      edit_router: '編輯路由器',
      Return_to_router_list: '返回路由器列表',
      please_enter: '請輸入',
      index: '序號',
      name: '路由器代號',
      AnotherName: '路由器名稱',
      linkType: '聯網模式',
      channel: '訊號頻道',
      remark: '備註',
      save: '保存',
      action: '操作',
      edit: '編輯',
      delete: '刪除',
      delete_message: '確定要刪除嗎?',
      mod: '聯網模式',
      Lan: '區域網路',
      Internet: '網際網路',
      time: '重整',
      save_success: '系統與收集器重整完畢'
    }
  },
  Card: {
    New_Card: '新建卡片',
    edit_Card: '編輯卡片',
    Return_to_Card_list: '返回卡片列表',
    please_enter: '請輸入',
    index: '序號',
    userName: '持有人',
    cardNo: '卡片編號',
    workTypeName: '工種',
    action: '操作',
    edit: '編輯',
    delete: '刪除',
    delete_message: '確定要刪除嗎?',
    save: '保存',
    error: '錯誤',
    error_message1: '<p>卡號重複</p>',
    error_message2: '<p>有資料未填寫</p>'
  },
  Product: {
    New_Product: '新建產品',
    edit_Product: '編輯產品',
    Return_to_Product_list: '返回產品列表',
    please_enter: '請輸入',
    index: '序號',
    productNo: '編號',
    name: '名稱',
    latDensity: '緯密',
    kaidu: '開度',
    width: '寬度',
    specifications: '規格',
    valid: '有效',
    yes: '是',
    no: '否',
    action: '操作',
    edit: '編輯',
    delete: '刪除',
    delete_message: '確實要刪除嗎?',
    save: '保存',
    error: '錯誤',
    error_message: '<p>有資料未填寫</p>',
    please_enter_kaidu: '请输入（≧1）',
    please_enter_mm: '請輸入（單位：mm）',
    please_enter_latDensity: '請輸入（單位：緯/cm）',
    Message: {
      productNo: '請輸入產品編號',
      name: '請輸入名稱',
      latDensity: '請輸入緯密',
      kaidu: '請輸入開度',
      width: '請輸入寬度'
    }
  },
  Order: {
    New_Order: '新建訂單',
    edit_Order: '編輯訂單',
    Return_to_Order_list: '返回訂單列表',
    please_enter: '請輸入',
    please_enter_date: '請輸入日期',
    action: '操作',
    edit: '編輯',
    delete: '刪除',
    save: '保存',
    error: '錯誤',
    error_message1: '<p>未添加產品至訂單</p>',
    error_message2: '<p>訂單資訊未填</p>',
    error_message3: '<p>數量未填</p>',
    error_message4: '<p>單位未填</p>',
    error_message5: '<p>交付未填</p>',
    error_message6: '<p>請先選擇左側產品</p>',
    delete_message: '確定要刪除嗎?',
    change_message: '确定要反結案嗎?',
    orderNo: '訂單編號',
    customer: '客戶',
    ordersTime: '接單日期',
    salesman: '接單業務',
    index: '序號',
    productNo: '產品編號',
    num: '數量',
    unit: '單位',
    attritionRate: '耗損率(%)',
    deliveryTime: '訂單交付日期',
    remark: '備註',
    add: '添加到訂單',
    Product_list: '產品列表',
    search: '編號/名稱',
    No_scheduling: '未排產',
    Not_production: '未投產',
    Producting: '已投產',
    Case_closed: '已結案',
    name: '名稱',
    Meter: '米',
    Yard: '碼',
    Gross: '籮',
    status: '狀態',
    Message: {
      orderNo: '請輸入產品編號',
      ordersTime: '請輸入接單日期',
      customer: '請輸入客戶名',
      salesman: '請輸入業務員'
    }
  },
  Login: {
    username: '請輸入用戶名',
    password: '請輸入密碼',
    systemCode: '請輸入系統號',
    language: '請選擇語言',
    login: '登錄',
    system: '系統登錄',
    changePw: '修改密碼',
    logout: '退出登錄',
    Information: '個人資訊'
  },
  ChangePw: {
    oldPassword: '輸入舊密碼:',
    newPassword: '輸入新密碼:',
    comfirmPassword: '確認新密碼:',
    save: '保存',
    error: '兩次密碼輸入不一致',
    success: '修改成功',
    ChangePw: '修改密碼'
  },
  monitor: {
    Collector: {
      index: '序號',
      name: '名稱',
      group: '群組',
      deviceNo: '編號',
      rpm: '機器轉速',
      status: '機器狀態',
      status1: '設備狀態',
      error: '故障訊息',
      worker: '刷卡人員',
      workType: '刷卡狀態',
      lastTime: '時間',
      timeout: '離線',
      trial: '試運行',
      standby: '待排產',
      run: '生產中',
      orderNo: '訂單',
      producNo: '貨號',
      stop: ' 待機',
      warp: ' 經紗 ',
      weft: ' 緯紗 ',
      thread: ' 底線 ',
      roll: ' 卷取 '
    },
    Order: {
      index: '序號',
      orderNo: '訂單',
      producNo: '貨號',
      salesman: '業務',
      ordersTime: '接單時間',
      output: '產量',
      num: '訂單量',
      unit: '單位',
      countdata: '機台數',
      name: '名稱',
      rpm: '機器轉速',
      worker: '刷卡人員',
      workType: '刷卡狀態',
      DailyOutput: '今日產量',
      deliveryTime: '訂單交期',
      today: '今日產量',
      completed: '已生產完成',
      fastestdelivery: '預估交期',
      please_enter_date1: '訂單交期起始日期',
      please_enter_date2: '訂單交期结束日期',
      Meter: '米',
      Yard: '碼',
      Gross: '籮'
    }
  },
  data: {
    Device: {
      name: '機台',
      date: '日期',
      group: '群組',
      output: '產量',
      unit: '單位',
      runTotalTime: '運行時間',
      stopTime: '停機次數',
      stopTotalTime: '停機時間',
      error1Time: '經紗次數',
      error1TotalTime: '經紗時間',
      error2Time: '緯紗次數',
      error2TotalTime: '緯紗時間',
      error3Time: '底紗次數',
      error3TotalTime: '底紗時間',
      error4Time: '捲曲次數',
      error4TotalTime: '捲曲時間',
      S: '秒',
      M: '分',
      H: '時',
      D: '天',
      Meter: '米',
      output_report: '產能報表',
      run_report: '運行狀況報表',
      please_enter: '請選擇',
      please_enter_date: '請選擇日期',
      start_date: '起始日期',
      end_date: '結束日期',
      ok: '確定',
      out: '輸出',
      status: '運行狀況'
    },
    Order: {
      orderNo: '訂單编号',
      productNo: '貨號',
      collectorName: '機台',
      salesman: '接單業務',
      customer: '客戶',
      ordersTime: '接單時間',
      productTime: '投產時間',
      output: '實際產量',
      target: '目標產量',
      num: '訂單量',
      unit: '單位',
      deliveryTime: '客戶交期',
      Meter: '米',
      Yard: '碼',
      Gross: '籮',
      Order_report: '訂單報表',
      ok: '確定',
      out: '輸出',
      please_enter: '請選擇',
      please_enter_date: '請選擇日期',
      start_date: '起始日期',
      end_date: '結束日期',
      time_range: '時間段',
      No_scheduling: '未排產',
      Not_production: '未投產',
      Producting: '已投產',
      Case_closed: '已結案',
      status: '狀態',
      history: '歷史訂單'
    }
  },
  setting: {
    Basic_Information: '基本資訊',
    company_information: '公司資訊',
    Contact_information: '聯繫方式',
    save: '保存',
    please_enter: '請輸入',
    username: '用戶名:',
    name: '姓名:',
    company: '公司:',
    workNo: '工號:',
    department: '部門:',
    workPosition: '職位:',
    role: '角色:',
    phone: '電話:',
    eMail: '郵箱:',
    qq: 'QQ號碼:',
    wechat: '微信:',
    System_setting: '系統配置',
    language: '語言:',
    zhcn: '簡體中文',
    zhtw: '繁體中文',
    enUS: 'English',
    jaJP: '日本語',
    viVN: 'Việt Nam - Tiếng việt',
    thTH: 'ไทย - ไทย (แปรตรงตัว)'
  },
  plan: {
    Collector: {
      search: '機台篩選',
      name: '機台',
      one: '第一批',
      two: '第二批',
      three: '第三批',
      four: '第四批',
      fiv: '第五批',
      six: '第六批',
      orderNo: '訂單號:',
      productNo: '產品號:',
      row: '條數:',
      delete_message: '確定是否停產?',
      yes: '投產',
      no: '停產'
    },
    Order: {
      orderNo: '訂單號',
      customer: '客戶',
      ordersTime: '接單日期',
      salesman: '業務員',
      index: '序號',
      productNo: '產品編號',
      num: '數量',
      unit: '單位',
      attritionRate: '耗損率(%)',
      output: '完成數',
      deliveryTime: '交付日期',
      action: '操作',
      Meter: '米',
      Yard: '碼',
      Gross: '籮',
      delete_message: '確實是否結案?',
      case1: '結案',
      case2: '已結案'
    },
    Production: {
      productNo: '產品號',
      productName: '產品名稱',
      deliveryTime: '客戶交期',
      num: '數量',
      name: '機台名稱',
      count: '條數',
      width: '寬度',
      collectorName: '機台名稱',
      orderNo: '訂單號',
      planIndex: '批次',
      row: '條數',
      action: '操作',
      delete: '刪除',
      error: '錯誤',
      error_message: '<p>條數未選擇</p>',
      planClick: '已排產計畫列表',
      please_enter: '請輸入',
      deviceNo: '編號',
      save: '確定',
      save1: '派單',
      save2: '插單',
      save3: '並產',
      No_scheduling: '未排產',
      Not_production: '未投產',
      Producting: '已投產',
      Case_closed: '已結案',
      status: '狀態',
      no: '停產',
      delete_message: '確實要刪除嗎?',
      searchCollector: '機台名稱',
      chooose_order: '1.選擇訂單',
      choose_device: '2.選擇機台',
      choose_plan: '3.排產計畫',
      list: '已排產計畫列表',
      message: '此產品已經結案'
    }
  },
  People: {
    index: '序號',
    name: '姓名',
    workNo: '工號',
    sex: '性別',
    boy: '男',
    girl: '女',
    phone: '電話',
    entryTime: '入職時間',
    wechat: '微信號',
    qq: 'QQ號',
    working: '在職',
    working1: '在職',
    working2: '離職',
    yes: '是',
    no: '否',
    action: '操作',
    edit: '編輯',
    edit_People: '編輯人員',
    Return_to_People_list: '返回人員列表',
    please_enter: '請輸入',
    please_enter_date: '選擇日期',
    save: '保存'
  },
  Maintain: {
    index: '序號',
    DeviceName: '機台名稱',
    username: '維修人員',
    startTime: '開始時間',
    endTime: '結束時間',
    remark: '備註',
    action: '操作',
    edit: '編輯',
    edit_Maintain: '編輯維修紀錄',
    Return_to_Maintain_list: '返回維修列表',
    save: '保存',
    please_enter: '請輸入',
    please_enter_date1: '開始時間起始日期',
    please_enter_date2: '開始時間结束日期'
  },
  Permission: {
    super_admin: '超級系統管理',
    system: '系統管理',
    device: '設備管理',
    card: '卡片管理',
    people: '人員管理',
    product: '產品管理',
    order: '訂單管理',
    production_plan: '排產管理',
    monitor: '即時監控',
    report_export: '歷史報表',
    R: '讀',
    W: '寫',
    RW: '讀寫'
  }
}, zh, zhE)

export default zhCn



// WEBPACK FOOTER //
// ./src/lang/zh-tw.js